import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as LucideVue from 'lucide-vue'
import videoPlayer from 'vue-video-player'
import "video.js/dist/video-js.css";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/css/tailwind.css'
import permission from './directives/permission'

Vue.use(videoPlayer)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.use(elementUI)

const lucideReservedNames = new Set([
  'Circle',
  'Component',
  'Filter',
  'Image',
  'Text',
  'View'
])

// 注册 Lucide 图标，避免与 Vue/HTML 保留标签重名
Object.entries(LucideVue).forEach(([name, component]) => {
  if (component && component.render) {
    const registrationName = lucideReservedNames.has(name) ? `Lucide${name}` : name
    Vue.component(registrationName, component)
  }
})

// 注册权限指令
Vue.directive('permission', permission)

//EventBus事件中转
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
